import { ShaderMaterial, Vector4 } from 'three';

import vs from './glsl/BakedScene.vs';
import fs from './glsl/BakedScene.fs';

export class BakedSceneMaterial extends ShaderMaterial {
  constructor(options) {  
    super({
      vertexShader: vs,
      fragmentShader: fs,
      uniforms: {
        map: { value: null },
        offsetRepeat: { value: new Vector4( 0, 0, 1, 1 ) },
        opacity: { value: 1 }
      }
    });

    if (options.map !== undefined) {
      this.uniforms.map.value = options.map;
      this.defines.USE_MAP = true;
    }
  }
}
